import mapboxgl from 'mapbox-gl';

class CustomZoomControl implements mapboxgl.IControl {
  private container: HTMLDivElement | null = null;
  private mapInstance: mapboxgl.Map | null = null;

  // make them more visible on the map
  onAdd(map: mapboxgl.Map): HTMLElement {
    const leaveBgColor = 'color-mix(in srgb, #79767C 80%, transparent)';
    const hoverBgColor = 'color-mix(in srgb, #CFC970 80%, transparent)';
    const cssText = `
      width: 30px;
      height: 30px;
      background-color: color-mix(in srgb, #79767C 80%, transparent);
      border: none;
      border-radius: 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      margin: 0;
  `;
    this.mapInstance = map;
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    this.container.style.cssText = `
      display: flex;
      flex-direction: row;
      background: transparent;
      gap: 5px;
      border: none;
      box-shadow: none;
      padding: 0;
    `;

    const zoomInButton = document.createElement('button');
    zoomInButton.className = 'custom-zoom-in';
    zoomInButton.type = 'button';
    zoomInButton.setAttribute('aria-label', 'Zoom in');
    zoomInButton.innerHTML =
      '<span style="color: #fff; font-size: 0.75rem; font-weight: 300; line-height: 1; display: flex; align-items: center; justify-content: center;">+</span>';
    zoomInButton.style.cssText = cssText;
    zoomInButton.addEventListener('mouseenter', () => {
      zoomInButton.style.backgroundColor = hoverBgColor;
    });
    zoomInButton.addEventListener('mouseleave', () => {
      zoomInButton.style.backgroundColor = leaveBgColor;
    });
    zoomInButton.addEventListener('click', () => {
      if (this.mapInstance) {
        this.mapInstance.zoomIn();
      }
    });

    const zoomOutButton = document.createElement('button');
    zoomOutButton.className = 'custom-zoom-out';
    zoomOutButton.type = 'button';
    zoomOutButton.setAttribute('aria-label', 'Zoom out');
    zoomOutButton.innerHTML =
      '<span style="color: #fff; font-size: 0.75rem; font-weight: 300; line-height: 1; display: flex; align-items: center; justify-content: center;">−</span>';
    zoomOutButton.style.cssText = cssText;
    zoomOutButton.addEventListener('mouseenter', () => {
      zoomOutButton.style.backgroundColor = hoverBgColor;
    });
    zoomOutButton.addEventListener('mouseleave', () => {
      zoomOutButton.style.backgroundColor = leaveBgColor;
    });
    zoomOutButton.addEventListener('click', () => {
      if (this.mapInstance) {
        this.mapInstance.zoomOut();
      }
    });

    this.container.appendChild(zoomInButton);
    this.container.appendChild(zoomOutButton);

    return this.container;
  }

  onRemove(): void {
    if (this.container && this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
    this.mapInstance = null;
    this.container = null;
  }

  // eslint-disable-next-line class-methods-use-this
  getDefaultPosition(): 'top-left' {
    return 'top-left';
  }
}

export default CustomZoomControl;
